'use client';

import React from 'react';
import { twJoin } from 'tailwind-merge';
import Button from '../Button';
import { SharedButtonLinkProps } from './types';

interface ExternalAreaButtonProps extends SharedButtonLinkProps {
  className?: string;
}

// CTA has only an external area link, no internal link/bundle/variant: the
// button opens the shipping-availability modal instead of navigating.
export default function ExternalAreaButton({
  className,
  text,
  children,
  variant,
  noUppercase,
  ariaLabel,
  tileElementTrackingId,
  onClick,
  modal,
}: Readonly<ExternalAreaButtonProps>) {
  return (
    <>
      <Button
        className={twJoin(className, noUppercase && 'normal-case')}
        variant={variant}
        onClick={onClick}
        aria-label={ariaLabel}
        data-tile-element-id={tileElementTrackingId}
      >
        {text}
        {children}
      </Button>
      {modal}
    </>
  );
}
